export const CONTACT_FOR_SALE_SITUATION_KEYS = [
    'first_time_buyer',
    'looking_to_invest',
    'no_property_to_sell',
    'offer_on_own_property',
    'other',
    'property_to_let',
    'property_to_sell',
    'recently_sold'
];
